import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  /*{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'cil-speedometer'
  },
  {
    name: 'Lista',
    icon: 'cil-spreadsheet',
    url: '/organizations'
  },*/
  /**
   * Ide szúrja be a sidebar constructor az API-ról érkező helyszíneket.
   */
  {
    name: 'Térkép',
    icon: 'cil-map',
    url: '/organizations/map'
  },
  {
    name: 'Összes kamera',
    icon: 'cil-camera',
    url: '/cameras/grid'
  }/*,
  {
    name: 'Monitor 1',
    icon: 'cil-grid',
    url: '/cameras/matrix'
  }*/
];
